import { useReducer } from "react";
import { SEARCH_RESULT_TYPE } from "common/constants";
import { parseCoordinates } from "common/utils/coordinates";
import { OmniboxSearchResult } from "../../../generated/graphql";

export type SearchResultsState = {
  debouncedQuery: string | null;
  isTextSearch: boolean | null;
  loading: boolean;
  results: OmniboxSearchResult[] | null;
  hoveredSearchResult: {
    feature: {
      id: string;
      featureType: SEARCH_RESULT_TYPE;
    };
    hoverSource: "results" | "map";
  } | null;
};

export type SearchResultsAction =
  | {
      type: "searchStarted";
      query: string;
    }
  | {
      type: "searchComplete";
      results: OmniboxSearchResult[] | null;
    }
  | {
      type: "resetSearch";
    }
  | {
      type: "setHoveredSearchResult";
      feature: {
        id: string;
        featureType: SEARCH_RESULT_TYPE;
      };
      hoverSource: "results" | "map";
    }
  | {
      type: "clearHoveredSearchResult";
    };

export const INITIAL_SEARCH_RESULTS_STATE: SearchResultsState = {
  debouncedQuery: null,
  isTextSearch: null,
  loading: false,
  results: null,
  hoveredSearchResult: null,
};

export const useSearchResultsState = (
  initialState: SearchResultsState = INITIAL_SEARCH_RESULTS_STATE,
) =>
  useReducer((state: SearchResultsState, action: SearchResultsAction) => {
    switch (action.type) {
      case "searchStarted":
        return {
          ...state,
          loading: true,
          isTextSearch: parseCoordinates(action.query) === null,
          debouncedQuery: action.query,
          results: null,
        };
      case "searchComplete":
        return { ...state, results: action.results, loading: false };
      case "resetSearch":
        return INITIAL_SEARCH_RESULTS_STATE;
      case "setHoveredSearchResult":
        return {
          ...state,
          hoveredSearchResult: {
            feature: action.feature,
            hoverSource: action.hoverSource,
          },
        };
      case "clearHoveredSearchResult":
        return {
          ...state,
          hoveredSearchResult: null,
        };
    }
  }, initialState);
